import React from 'react'

const CellDataPlan: React.FC = () => {
  return (
    <div>
      <div className='subscriptions-pricing__cell-data-lead'>
        <h2 className='subscriptions-pricing__cell-data-supertitle'>Starter Kit</h2>
        <h3 className='subscriptions-pricing__cell-data-title'>Get Up and Running with Ease</h3>
        <p className='subscriptions-pricing__cell-data-description'>Everything you need to kickstart your automation journey.</p>
      </div>

      <div className='subscriptions-pricing__cell-data-card'>
        <div className='subscriptions-pricing__cell-data-plan-name'>Cell Data</div>
        <div className='subscriptions-pricing__cell-data-plan-price'>$500</div>
        <div className='subscriptions-pricing__cell-data-plan-price-per'>Billed annually (available in 1- or 2-year plans).</div>
        <div className='subscriptions-pricing__cell-data-plan-description'>Stay connected with secure, always-on LTE. Uninterrupted access to Vention’s cloud tools and remote support</div>
        <ul className='subscriptions-pricing__plan-list'>
          <li>
            <i className='subscriptions-pricing__plan-list-item-icon fal fa-circle-check'></i>
            <p className='subscriptions-pricing__plan-list-item-text'>Includes RemoteSupport, RemoteView, MachineAnalytics, and log monitoring</p>
          </li>
          <li>
            <i className='subscriptions-pricing__plan-list-item-icon fal fa-circle-check'></i>
            <p className='subscriptions-pricing__plan-list-item-text'>Lights-out LTE connectivity — no additional IT infrastructure required</p>
          </li>
        </ul>
        <a className='subscriptions-pricing__subscription-card-link' href='/contact/new?choice=talk+to+expert'>
          Contact us
        </a>
       </div>
    </div>
  )
}

export default CellDataPlan
